import React, { useState, useEffect } from 'react';
import { ModalWrapper, ButtonGroup } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { Form, Button, Space, message, Upload } from 'antd';
import { CheckOutlined } from '@ant-design/icons'
import { UploadOutlined, DownloadOutlined, PaperClipOutlined } from '@ant-design/icons'
import { UploadFile } from 'antd/lib/upload/interface';
import * as XLSX from 'xlsx';
import axios from 'axios';
import { endpoints } from 'services';
import { SERVER_URL } from 'commons/constants';

export interface SeminarExcelUploadModalProps extends PopupProps {
    lectureInfo: LectureInfoDto;
}

const SeminarExcelUploadModal = ({ 
    isOpen, 
    onClose, 
    lectureInfo}: SeminarExcelUploadModalProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    
    const [isUpload, setIsUpload] = useState<boolean>(false);
    const [uploadFileList, setUploadFileList] = useState<UploadFile[]>([]);
    const [uploadStudents, setUploadStudents] = useState<AppStudentExcelItemDto[]>([]);
  /* ======================================================
  * hooks
  * ====================================================== */


   /* ======================================================
   * variables
   * ====================================================== */
  const [form] = Form.useForm();

   /* ======================================================
   * events
   * ====================================================== */
   const readExcel = async (file: File) => {
    const fileReader = new FileReader();
    fileReader.readAsArrayBuffer(file);
    fileReader.onload = (e: ProgressEvent<FileReader>) => {
      if (!e.target) return;
      const bufferArray = e.target.result;
      const fileInformation = XLSX.read(bufferArray, {
        type: 'buffer',
        cellText: false,
        cellDates: true,
      });
      const sheetName = fileInformation.SheetNames[0];
      const rawData = fileInformation.Sheets[sheetName];
      const data = XLSX.utils.sheet_to_json(rawData);
      
      let chk = true;
      let isRead = false;
      const students : AppStudentExcelItemDto[] = [];

      data.forEach((item:any) => {
        if (item[Object.keys(item)[0]] === 'NO') {
            isRead = true;    
        } else if (isRead) {
            if (!!item.__EMPTY_1 || 
                !!item.__EMPTY_2 ||
                !!item.__EMPTY_3 ||
                !!item.__EMPTY_4 ||                
                !!item.__EMPTY_6 ||
                !!item.__EMPTY_7) {

                if (!item.__EMPTY_1 || 
                    !item.__EMPTY_2 ||
                    !item.__EMPTY_3 ||
                    !item.__EMPTY_4 ||
                    !item.__EMPTY_6 ||
                    !item.__EMPTY_7) {
                    chk = false;
                    return true;
                } else {
                    // 교육생 정보 담아주기
                    students.push({
                        company: String(item.__EMPTY_1),
                        department: String(item.__EMPTY_2),
                        name_kor: String(item.__EMPTY_3),
                        position: String(item.__EMPTY_4),                        
                        job: item.__EMPTY_5 ? String(item.__EMPTY_5): '',                        
                        phone: String(item.__EMPTY_6),
                        email: String(item.__EMPTY_7),                        
                        role: item.__EMPTY_8 ? String(item.__EMPTY_8): '',
                        duty: '',
                        age: '',
                        sex: '',
                        name_eng: '',
                    })
                }
            } else {
                return true;
                
            }
        }
      });
      if (chk) {
        setUploadStudents(students);
      } else {
        alert("등록하신 신청서의 \n기업명/부서/성명/직급/휴대폰/이메일 중 \n일부 항목이 정상적으로 기입되지 않았습니다.\n확인 후 다시 업로드해주시기 바랍니다.");
        setUploadFileList([]);
      }
     };
   };

   const onSubmit = (e) => {
    if (uploadStudents.length === 0) {
        alert("등록할 교육생이 없습니다.")
        return true;
    }

    setIsUpload(true);    
    const ajaxForm = new FormData();
    ajaxForm.append('b2c_group_srl', lectureInfo.id.toString());
    uploadStudents.forEach((student, index) => {
        ajaxForm.append('students['+index+'].company',student.company?student.company:'');
        ajaxForm.append('students['+index+'].department',student.department);
        ajaxForm.append('students['+index+'].name_kor',student.name_kor);
        ajaxForm.append('students['+index+'].position',student.position);
        if (student.job) ajaxForm.append('students['+index+'].job',student.job);
        if (student.role) ajaxForm.append('students['+index+'].role',student.role);
        ajaxForm.append('students['+index+'].phone',student.phone);
        ajaxForm.append('students['+index+'].email',student.email);
    });  

    axios.post(
        SERVER_URL + endpoints.b2c.seminar.student.upload,
        ajaxForm
      )
        .then((res) => {
            switch (res.data.code) {
                case 200:
                    message.info('정보가 등록 되었습니다.', 1);
                    onClose?.(true);
                break;
                default:  
                    message.error('등록중 오류 발생하였습니다.', 1);
                break;
            };
            setIsUpload(false);
        })
        .catch(() => {
          message.error('에러가 발생했습니다.', 1);
          setIsUpload(false);
        });

   }
  /* ======================================================
   * effects
   * ====================================================== */


    return (
    <ModalWrapper open={isOpen} onCancel={onClose} width={500} title={'세미나 교육생 단체등록'} closable>
        <Space direction='vertical' style={{width:'100%'}}>
            <h4 style={{marginBottom:'0px'}}>{lectureInfo.lecture_title}</h4>
            <label ><CheckOutlined /> 단체등록</label>
            <Form
                form={form}
                name="StudentInfo"
                layout="horizontal"  
                labelCol={{ flex: '120px' }}
                onFinish={onSubmit}
                style={{width:'100%'}}
                autoComplete="off"
            >
                <Form.Item label={'단체 신청서 작성'}>
                    <a href="/assets/excel/HSG_세미나_단체신청서양식.xlsx"><Button icon={<DownloadOutlined />}>신청서 다운</Button></a>     
                </Form.Item> 
                <Form.Item label={'신청서 업로드'}>
                    <Upload
                        fileList={uploadFileList}
                        onChange={({ fileList: list }) => {
                            setUploadFileList(list);
                        }}   
                        beforeUpload={(file, filelist) => {
                            readExcel(file);
                        }}                                           
                        customRequest={() => true}
                        maxCount={1}
                        accept=".xlsx"
                        iconRender={()=><PaperClipOutlined />}
                    >
                        <Button icon={<UploadOutlined />} style={{fontSize:'12px'}}>등록</Button>
                    </Upload>        
                </Form.Item> 
                <Form.Item label={'교육생수'}>
                    <label>{uploadStudents.length}명</label>
                </Form.Item>  
                <ButtonGroup className={'buttonsWrapper'}>
                    <Button onClick={onClose} style={{marginRight: "5px"}} disabled={isUpload}>닫기</Button>                    
                    <Button htmlType="submit"  type="primary" disabled={isUpload}>{'등록'}</Button>                    
                </ButtonGroup> 
            </Form>
        </Space>        
    </ModalWrapper>  
    )    
};

export default SeminarExcelUploadModal;    